module.exports = __webpack_public_path__ + "img/green_046.37563e31.png";